import { Controller } from '@hotwired/stimulus';
import {
  capitalize, concat, each, extend, includes, isEmpty, isString, map, sortBy, template,
} from 'lodash';

const NAMESPACE_CSS = '.cifra-sec';
const SELECTOR_ESTRUCTURA_CARRUSEL = template(`
<div class="cifra-sec-wrapper">
  <% _.each(fixedTypes, function(tipo){%>
    <h3><%= I18n.t(_.capitalize(tipo)) %></h3>
    <section class="cifra-sec-<%= tipo %>"></section>
  <% }); %>
</div>
`);
const RADIO_ESTRUCTURA = template(`
<div class="form-group">
  <div class="pretty p-icon p-round">
    <input class="cifra-sec-input <%= tipo %> <%= opcional ? 'radio-empty' : '' %>" type="radio"
      name="<%= nombreCampo %>"  value="<%= id %>"
      data-type="<%= tipo %>" <%= seleccionado ? 'checked' : '' %>>

    <div class="state p-cifra">
      <i class="icon fa fa-check"></i>
      <label for="<%= tipo + '-' + id %>"><%= nombre %></label>
    </div>
  </div>
</div>
`);

/**
 *
 * @deprecated Componente a destruir!!!!!!!! Solo se usa en pantalla de promoción
 */
/* global Cifra, Mn, Backbone, I18n, $ */
const SelectorEstructuraCarrusel = Mn.View.extend({
  template: SELECTOR_ESTRUCTURA_CARRUSEL,
  templateInput: RADIO_ESTRUCTURA,
  events: {
    'click .cifra-sec-input': '_siguientePaso',
    'change .cifra-sec-input': '_updateSeleccion',
  },
  modelEvents: {
    // eslint-disable-next-line quote-props
    'sync': 'render',
  },
  autoselect: true,
  fixedTypes: ['anno_lectivo', 'ensennanza', 'nivel', 'curso'],
  dynamicTypes: ['modalidad', 'grupo'],
  // Si es true, al mostrar los grupos de la modalidad, también muestra los grupos
  // del curso de esa modalidad
  incluirGruposCursoEnModalidad: false,
  initialize(options) {
    this.mergeOptions(options, [
      'fieldContext', 'fixedTypes', 'disabled', 'autoselect', 'incluirGruposCursoEnModalidad',
    ]);
    if (this.fixedTypes && isString(this.fixedTypes)) {
      this.fixedTypes = this.fixedTypes.split(' ');
    }
    this.selected = {};
    if (this.getOption('estructura')) {
      this.model = new Cifra.Models.EstructuraEscolar(this.getOption('estructura'));
    }
    if (!this.model) {
      this.model = new Cifra.Models.EstructuraEscolar({});
    }
    this.initialValues = this.getOption('initialValues') || this.$el.data('initial-values') || {};
    this.seleccion = new Backbone.Model();
  },
  templateContext() {
    return {
      fixedTypes: this.fixedTypes,
    };
  },
  /*
  Carga la estructura escolar y renderiza.
  Devuelve el promise de la llamada ajax
  */
  loadAndRender(options) {
    this._renderLoading();
    return this.model.fetch(options);
  },
  getSeleccionIds() {
    let campos = this.seleccion.toJSON();
    if (this.fieldContext) {
      campos = campos[this.fieldContext];
    }
    return campos;
  },
  getSeleccionDatosCompletos() {
    return this.model.getCompleteInfoForIds(this.getSeleccionIds());
  },
  // Array ordenado de los nombres de cada paso seleccionado
  getSeleccionNombres() {
    const nombres = [];
    const datosPath = this.getSeleccionDatosCompletos();
    each(Cifra.Models.EstructuraEscolar.prototype.TIPOS, (tipo) => {
      if (datosPath[tipo]) {
        nombres.push(datosPath[tipo].data.nombre);
      }
    });
    return nombres;
  },
  onRender() {
    const view = this;
    if (this.loading) {
      // TODO: En vez de hacer esto, usar otro template
      return;
    }
    this.iniciando = true;
    this._conectarSteps();
    this._renderEstructura('root');
    each(this.fixedTypes, (tipo) => {
      const valorInicial = view.initialValues[`${tipo}_id`];
      if (valorInicial) {
        view._renderEstructura(tipo, valorInicial);
        view.wizard.steps('next');
      }
    });
    this.iniciando = false;
  },
  _conectarSteps() {
    const view = this;
    this.wizard = this.$('.cifra-sec-wrapper').steps({
      headerTag: 'h3',
      bodyTag: 'section',
      transitionEffect: 'slideLeft',
      autoFocus: true,
      titleTemplate: '#title#',
      enablePagination: false,
      onStepChanged() {
        if (!view.iniciando) {
          // Cuando vuelven para atrás, volvemos a deshabilitar las siguientes páginas
          view.$('.steps .current').nextAll().removeClass('done').addClass('disabled');
          view.$('.body.current').nextAll().html('');
          view._updateSeleccion();
        }
      },
    });
  },
  _siguientePaso(e) {
    const $input = $(e.currentTarget);
    const tipo = $input.data('type');
    const id = $input.val();

    this._renderEstructura(tipo, id);
    const haySiguiente = this.wizard.steps('next');
    if (haySiguiente && this.autoselect) {
      this._autoselect();
    }
  },
  _updateSeleccion() {
    this.seleccion.clear({ silent: true });
    this.seleccion.set(Backbone.Syphon.serialize(this.$el));

    this.triggerMethod('update:seleccion', this.seleccion);
  },
  _renderLoading() {
    this.loading = true;
    this.$el.html('<div class="text-center"><i class="text-cifra fa fa-circle-notch fa-spin"></i> Cargando...</div>');
    this.loading = false;
  },
  _nombreCampo(tipo) {
    let nombre = `${tipo}_id`;
    if (this.fieldContext) {
      nombre = `${this.fieldContext}[${nombre}]`;
    }
    return nombre;
  },
  _renderEstructura(tipo, id) {
    const view = this;
    let datosTipo;
    if (tipo === 'root') {
      datosTipo = this._getRootInfo();
    } else {
      datosTipo = this.model.findByType(tipo, id);
    }
    let tipoHijos = null;
    let hijos = null;
    // Si seleccionan Matricular sin promoción no existe el tipo, es fake
    if (datosTipo) {
      tipoHijos = datosTipo.childrenType;
      hijos = datosTipo.data[datosTipo.childrenName];
      if (isEmpty(hijos)) {
        hijos = this._loadGrupos(datosTipo);
        if (!isEmpty(hijos)) {
          tipoHijos = 'grupo';
        }
      }
    }

    this._controlSeccionDinamica(tipoHijos, hijos);

    const $seccion = this.$(`${NAMESPACE_CSS}-${tipoHijos}`);
    $seccion.html('');
    if (hijos && hijos.length > 0) {
      if (hijos[0].type === 'modalidad') {
        hijos.push({
          type: 'modalidad',
          id: false,
          nombre: I18n.t('matricular_sin_modalidad'),
        });
      }

      each(hijos, (estructura) => {
        const html = view.templateInput({
          tipo: estructura.type,
          id: estructura.id,
          nombre: estructura.nombre,
          nombreCampo: view._nombreCampo(estructura.type),
          seleccionado: view.initialValues[`${estructura.type}_id`] === estructura.id,
          opcional: includes(view.dynamicTypes, estructura.type),
        });
        $seccion.append(html);
      });
    } else {
      $seccion.html('No hay elementos para seleccionar');
    }
  },
  _controlSeccionDinamica(tipo, valores) {
    if (includes(this.dynamicTypes, tipo)) {
      // Limpiamos todos los pasos siguientes y creamos el nuevo
      // dinámico solo si tenemos valores
      this._eliminarPasosSiguientes();
      if (!isEmpty(valores)) {
        this.wizard.steps('add', {
          title: I18n.t(capitalize(tipo)),
          content: '',
        });
        const $seccion = this.$('.content .body:last-child');
        $seccion.addClass(`cifra-sec-${tipo}`);
      }
    }
  },
  _autoselect() {
    const $input = this.$('.body.current .cifra-sec-input');
    // Si es un tipo dinámico no seleccionamos automáticamente porque por ejemplo
    // la modalidad puede ser opcional seleccionarla
    if ($input.length === 1 && !includes(this.dynamicTypes, $input.data('type'))) {
      $input.click();
    }
  },
  /*
  Simulamos el elemento raíz con los años como hijos tal y
  como tiene la estructura escolar para reutilizar el código.
  Si no está puesto el año lectivo en los tipos fijos se supone
  que nos indican el que seleccionan por defecto en los
  valores iniciales
  */
  _getRootInfo() {
    if (includes(this.fixedTypes, 'anno_lectivo')) {
      return {
        childrenName: 'annos_lectivos',
        childrenType: 'anno_lectivo',
        data: {
          annos_lectivos: map(this.model.getAnnosLectivos(), 'data'),
        },
      };
    // eslint-disable-next-line no-else-return
    } else {
      const datos = this.model.findByType('anno_lectivo', this.initialValues.anno_lectivo_id);
      // Si no lo encuentra simulamos un año sin enseñanzas
      return datos || {
        childrenType: 'ensennanza',
        data: {},
      };
    }
  },
  _loadGrupos(datosTipo) {
    let hijos = datosTipo.data.grupos;
    if (this.incluirGruposCursoEnModalidad && datosTipo.data.type === 'modalidad') {
      hijos = concat(hijos, datosTipo.parent.data.grupos);
    }
    return sortBy(hijos, 'nombre');
  },
  _eliminarPasosSiguientes() {
    // jquery steps no tiene forma de decirnos el nº de pasos así que
    // tenemos que acceder a la variable interna para descubrirlo
    let ultimoPaso = this.wizard.data('steps').length - 1;
    const actual = this.wizard.steps('getCurrentIndex');
    while (ultimoPaso > actual) {
      this.wizard.steps('remove', ultimoPaso);
      ultimoPaso -= 1;
    }
  },
});

/**
 * Selector de estructura con formato carrusel. Se va seleccionando cada parte
 * de la estructura en un wizar que va avanzando.
 * @deprecated: Habrá que rehacerlo con Vue
 */
export default class extends Controller {
  connect() {
    // Tienen que ser los data con jQuery porque los devuelve tranformados y dataset no
    const options = extend({
      el: this.element,
      checkAutoload: false,
    }, $(this.element).data());

    const selector = new SelectorEstructuraCarrusel(options);
    const loadData = {
      current: options.onlyCurrentYear === true,
      only_academic_groups: options.onlyAcademicGroups === true,
      anno_lectivo_id: options.annoLectivo || '',
      check_perms: options.checkPerms !== undefined ? options.checkPerms : '',
      add_grupos_profesor: options.addGruposProfesor !== false,
      add_grupos_hijos: options.addGruposHijos === true,
    };
    selector.loadAndRender({
      overlay: false,
      data: loadData,
    });
    this.selector = selector;
  }

  getSeleccionDatosCompletos() {
    this.selector.getSeleccionDatosCompletos();
  }

  getSeleccionNombres() {
    this.selector.getSeleccionNombres();
  }
}
